module.exports = __webpack_public_path__ + "img/38f9c0ff4c8cceb80e5f38e0de92f6aa_副本.13be5444.jpg";